module.exports = __webpack_public_path__ + "static/img/Top Logo_white.40bf63f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/svg/Top Logo_white.svg
// module id = KgrN
// module chunks = 5